module.exports = __webpack_public_path__ + "img/ayun-asset-based-screens.14f19694.svg";